import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Mixer from './Mixer';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Mixer />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js